<ppl-app-container [showCopyright]="showCopyright">
  <div class="align-in-center">
    <ppl-login-container *ngIf="mode === LoginCommonMode.Email"
                         [title]="titleEmailScreen"
                         [description]="descriptionText"
                         [error]="error"
                         [error_str]="errorMessage"
                         [loading]="loading">

      <ppl-form-container [formGroup]="authForm">
        <ppl-form-row>
          <ppl-input-container label="Email"
                               i18n-label="@@Email"
                               pplFormControlName="email">
            <input #emailInput
                   pplInput
                   tabindex="0"
                   name="email"
                   type="email"
                   autocomplete="username"
                   formControlName="email"
                   placeholder="Enter your email"
                   i18n-placeholder="@@Enter_your_email"
                   (keyup)="onKeyUp($event)" />
          </ppl-input-container>
        </ppl-form-row>
      </ppl-form-container>

      <div class="buttons">
        <button pplButton
                i18n="@@Continue"
                class="submit-button"
                [disabled]="!authForm.valid"
                (click)="onSubmit()">Continue</button>

        <ng-container *ngIf="googleShowLogin || microsoftShowLogin">
          <span i18n="@@or"
                class="separator">or</span>

          <button *ngIf="microsoftShowLogin"
                  pplButton
                  class="sso-button"
                  (click)="microsoftLogin.emit()">
            <span class="sso-button-wrapper">
              <ppl-icon svgIcon="microsoft-sign-in"
                        width="18px"></ppl-icon>
              <span i18n="@@SignInWithMicrosoft">Sign in with Microsoft</span>
            </span>
          </button>

          <button *ngIf="googleShowLogin"
                  pplButton
                  class="sso-button"
                  [disabled]="googleLoginDisabled"
                  (click)="googleLogin.emit()">
            <span class="sso-button-wrapper">
              <ppl-icon svgIcon="google-sign-in"
                        width="18px"></ppl-icon>
              <span i18n="@@SignInWithGoogle">Sign in with Google</span>
            </span>
          </button>
        </ng-container>
        <ng-container *ngIf="signUpUrl">
          <span class="description"
                i18n="@@Don't_have_an_account?">Don't have an account?</span>
          <a [href]="signUpUrl"
             i18n="@@Sign_up_for_trial"
             class="link white"
             target="_blank">Sign up for trial</a>
        </ng-container>
      </div>
    </ppl-login-container>

    <ppl-login-container *ngIf="mode === LoginCommonMode.Password"
                         [title]="titlePasswordScreen"
                         [error]="error"
                         [loading]="loading">
      <ppl-edit-email [user]="editEmailUser"
                      (edit)="onEdit()"></ppl-edit-email>

      <ppl-form-container [formGroup]="authForm">
        <ppl-form-row>
          <ppl-input-container label="Password"
                               i18n-label="@@Password"
                               pplFormControlName="password">
            <input type="email"
                   name="email"
                   tabindex="-1"
                   formControlName="email"
                   autocomplete="off"
                   class="hidden" />
            <input #passwordInput
                   pplInput
                   type="password"
                   name="password"
                   autocomplete="current-password"
                   formControlName="password"
                   placeholder="Enter your password"
                   i18n-placeholder="@@Enter_your_password"
                   (keyup)="onKeyUp($event)" />
          </ppl-input-container>
        </ppl-form-row>

        <ppl-form-row *ngIf="showRememberMe">
          <ppl-input-container pplFormControlName="remember">
            <ppl-checkbox formControlName="remember"
                          i18n="@@Remember_me">Remember me</ppl-checkbox>
          </ppl-input-container>
        </ppl-form-row>
      </ppl-form-container>

      <div class="buttons">
        <button pplButton
                i18n="@@Sign_in"
                class="submit-button"
                [disabled]="!authForm.valid"
                (click)="onSubmit()">Sign in</button>
        <a routerLink="/forgot_password"
           i18n="@@Forgot_password?"
           class="link">Forgot password?</a>
      </div>
    </ppl-login-container>
  </div>
</ppl-app-container>
